module.exports = __webpack_public_path__ + "img/support.6d9597fc.webp";